import React from "react";

import { ResourceLabelContentArg } from "@fullcalendar/resource-common";

import { AvatarWithName } from "@mapmycustomers/ui";

import ResourceObject from "../type/ResourceObject";

const ActivityAssigneeLabel: React.FC<ResourceLabelContentArg> = ({ resource }) => {
  if (!Object.keys(resource.extendedProps).length) {
    return null;
  }

  const payload = resource.extendedProps as ResourceObject;
  if (payload.user) {
    return <AvatarWithName user={payload.user} />;
  }

  return null;
};

export default ActivityAssigneeLabel;
